module.exports = __webpack_public_path__ + "static/media/Logo.8ec72801.png";